import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import types from "./types";
import reportBuilderAPIClientFactory from "../../backend/reportBuilderAPIClient";
import endPoint from "../../backend/endpoints";
import reportBuilderEndpoints from "../../backend/reportAPIEndpoints";

/**
 * DUPLICATE TEMPLATE API CALL
 */
function* duplicateTemplateStartHandlerSaga(action){
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	try {
		const { data } = yield call(
			reportBuilderApiClient.get,
			reportBuilderEndpoints?.duplicateTemplate(action.payload),
		);
		yield put({
			type: types.DUPLICATE_TEMPLATE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.DUPLICATE_TEMPLATE_ERROR,
			payload: e?.response?.data || e,
		});
	}
}

export function* duplicateTemplateStartWatcherSaga(){
	yield takeEvery(
		types.DUPLICATE_TEMPLATE_START,
		duplicateTemplateStartHandlerSaga,
	)
}

/**
 *  CREATE TEMPLATE API CALL
 */
function* createTemplateStartHandlerSaga(action) {
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	try {
		const { data } = yield call(
			reportBuilderApiClient.post,
			reportBuilderEndpoints.template,
			action.payload,
		);
		yield put({
			type: types.CREATE_TEMPLATE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.CREATE_TEMPLATE_ERROR,
			payload: e?.response?.data || e,
		});
	}
}
export function* createTemplateStartWatcherSaga() {
	yield takeLatest(types.CREATE_TEMPLATE_START, createTemplateStartHandlerSaga);
}

/**
 * TEMPLATE LIST API CALL
 * */
function* templateListStartHandlerSaga(action) {
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	try {
		const { data } = yield call(
			reportBuilderApiClient.get,
			endPoint.listCreateTemplate(action.payload),
		);
		yield put({
			type: types.TEMPLATE_LIST_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.TEMPLATE_LIST_ERROR,
			payload: e?.response?.data || e,
		});
	}
}

export function* templateListStartWatcherSaga() {
	yield takeLatest(types.TEMPLATE_LIST_START, templateListStartHandlerSaga);
}

/**
 *  DELETE TEMPLATE API CALL
 */
function* deleteTemplateStartHandlerSaga(action) {
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	try {
		const { data } = yield call(
			reportBuilderApiClient.delete,
			endPoint.retrieveUpdateDeleteTemplate(action.payload),
		);
		yield put({
			type: types.DELETE_TEMPLATE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.DELETE_TEMPLATE_ERROR,
			payload: e?.response?.data || e,
		});
	}
}
export function* deleteTemplateStartWatcherSaga() {
	yield takeLatest(types.DELETE_TEMPLATE_START, deleteTemplateStartHandlerSaga);
}

/**
 *  TEMPLATE DETAILS API CALL
 */
function* templateDetailsStartHandlerSaga(action) {
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	try {
		const { data } = yield call(
			reportBuilderApiClient.get,
			endPoint.retrieveUpdateDeleteTemplate(action.payload),
		);
		yield put({
			type: types.TEMPLATE_DETAILS_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.TEMPLATE_DETAILS_ERROR,
			payload: e?.response?.data || e,
		});
	}
}
export function* templateDetailsStartWatcherSaga() {
	yield takeLatest(
		types.TEMPLATE_DETAILS_START,
		templateDetailsStartHandlerSaga,
	);
}

/**
 *  TEMPLATE UPDATE API CALL
 */
function* updateTemplateStartHandlerSaga(action) {
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	const { id, newTemplate } = action.payload;
	try {
		const { data } = yield call(
			reportBuilderApiClient.put,
			endPoint.retrieveUpdateDeleteTemplate(id),
			newTemplate,
		);
		yield put({
			type: types.UPDATE_TEMPLATE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.UPDATE_TEMPLATE_ERROR,
			payload: e?.response?.data || e,
		});
	}
}
export function* updateTemplateStartWatcherSaga() {
	yield takeLatest(types.UPDATE_TEMPLATE_START, updateTemplateStartHandlerSaga);
}

/**
 *  GENERATE PDF AND SEND EMAIL API CALL
 */
function* generatePdfAndSendEmailStartHandlerSaga(action) {
	const reportBuilderApiClient = reportBuilderAPIClientFactory();
	try {
		const { template_id, emailData } = action.payload;
		const { data } = yield call(
			reportBuilderApiClient.post,
			endPoint.sendMailWithPdf(template_id),
			emailData,
		);
		yield put({
			type: types.SEND_MAIL_WITH_PDF_SUCCESS,
			payload: data,
		});
	} catch (e) {
		yield put({
			type: types.SEND_MAIL_WITH_PDF_ERROR,
			payload: e?.response?.data || e,
		});
	}
}
export function* generatePdfAndSendEmailStartWatcherSaga() {
	yield takeLatest(
		types.SEND_MAIL_WITH_PDF_START,
		generatePdfAndSendEmailStartHandlerSaga,
	);
}
